export default __webpack_public_path__ + "static/media/hot.0d40929c.png";